import { HttpClient } from '@angular/common/http';
import { CacheService } from '../services/cache.service';
import { Injectable } from '@angular/core';
import { WorkflowService } from '../services/workflow.service';

@Injectable()
export class LicensePaymentsService extends WorkflowService {
  constructor(http: HttpClient, cache: CacheService) {
    super(http, 'LicenseePayments', cache);
  }
}
